import React from 'react';

// STYLES
import styles from '@UILayer/UILayer.scss';
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getHttpError } from '@Managers/Redux/HttpState';
import { ReadyStateCheckIcon } from './ReadyStateCheck.icon';

export const ReadyStateCheckError: React.FC<{}> = ({}) => {
    const httpError = useAppSelector(getHttpError);

    return (
        <>
            {httpError && (
                <div className={styles.rsc_message_container}>
                    <div className={styles.rsc_message_icon}>
                        <ReadyStateCheckIcon />
                    </div>
                    <div className={styles.rsc_message_header}>Error</div>
                    <div className={styles.rsc_message_description}>
                        {httpError.statusCode && (
                            <>
                                HTTP status: {httpError.statusCode}
                                <br />
                            </>
                        )}
                        {httpError.code && (
                            <>
                                ER_CODE: {httpError.code}
                                <br />
                            </>
                        )}
                        {httpError.error}
                    </div>
                </div>
            )}
        </>
    );
};
